/**
 * Sound Electric - Main Script
 * Handles dynamic footer year and page initialization
 */

/**
 * Update the footer year dynamically
 */
function updateFooterYear(): void {
  const yearElement = document.querySelector<HTMLElement>('.footer-year');

  if (yearElement) {
    const currentYear: number = new Date().getFullYear();
    yearElement.textContent = `© ${currentYear}`;
  }
}

/**
 * Initialize smooth scrolling
 */
function initSmoothScroll(): void {
  document.documentElement.style.scrollBehavior = 'smooth';
}

/**
 * Main initialization function
 */
function init(): void {
  updateFooterYear();
  initSmoothScroll();

  // Log successful initialization
  console.log('Sound Electric - Site loaded');
}

// Run initialization when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  // DOM already loaded
  init();
}

// Export for potential testing
export { updateFooterYear, initSmoothScroll, init };
